import React from "react";
import PropTypes from "prop-types";

export default class Label extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    for: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
  };

  render() {
    let { label, htmlFor, className } = this.props;

    return (
      <label htmlFor={htmlFor} className={className}>
        {label}{" "}
      </label>
    );
  }
}

Label.defaultProps = {
  label: "",
  for: "",
  class: "",
  style: {},
  onClick: () => {},
};
